// A trial's Year and its CO's year: a mismatch is only a warning (the API says the same in `warnings`).
import { CO_LABEL } from './contractLabel';

/** "Year 2025 differs from CO 4711's year 2026." - or null when they agree or either is not set. */
export function yearWarning(year, contract) {
  if (year === null || year === undefined || year === '' || !contract || contract.year == null) return null;
  if (Number(year) === Number(contract.year)) return null;
  return `Year ${year} differs from ${CO_LABEL} ${contract.co}'s year ${contract.year}.`;
}
